import React, { useState } from "react";
import TermsModal from "./Termsmodal";

const Facebook_URL = process.env.REACT_APP_FACEBOOK;
const Instagram_URL = process.env.REACT_APP_INSTAGRAM;
const X_URL = process.env.REACT_APP_X;
const GAMBLEAWARE_URL = process.env.REACT_APP_GAMBLEAWARE;

function Footer() {
  const [showPopup, setShowPopup] = useState(false);
  const [activeSection, setActiveSection] = useState("terms");

  const handleOpen = (section) => {
    setActiveSection(section);
    setShowPopup(true);
  };

  const handleClose = () => setShowPopup(false);

  return (
    <>
      <footer className="AF-footer">
        <div className="AF-container">
          <div className="AF-footer__sections">
            {/* IMPORTANT Section */}
            <div className="AF-footer__section">
              <h4 className="AF-footer__heading">IMPORTANT</h4>
              <ul className="AF-footer__linkList">
                <li>
                  <a href="/pricing">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="#" onClick={() => handleOpen("terms")}>
                    Terms and conditions
                  </a>
                </li>
                <li>
                  <a href="#" onClick={() => handleOpen("privacy")}>
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="mailto:contact@mybetbuilders.com?subject=Support%20request">
                    contact@mybetbuilders.com
                  </a>
                </li>
                
              </ul>
            </div>

            {/* QUICK LINKS Section */}
            {/* <div className="AF-footer__section">
              <h4 className="AF-footer__heading">FOLLOW MYBETBUILDER</h4>
              <div style={{display:'flex', gap:'5', listStyle:'none'}}>
                <li>
                    <a
                      href={Facebook_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="assets/images/facebook-logo.png"
                        alt="Facebook"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      href={Instagram_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="assets/images/instagram-logo.png"
                        alt="Instagram"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      href={X_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src="assets/images/x-logo.png" alt="Telegram" />{" "}
                    </a>
                  </li>
              </div>
            </div> */}

            {/* App Store & Social Icons */}

            <div className="AF-footer__section">
              <div className="AF-footer__socialIcons">
                <ul className="AF-footer__linkList">
                  {/* <h4 className="">FOLLOW MYBETBUILDER</h4> */}
                  <div style={{display:'flex', gap:'8', listStyle:'none', marginTop:'10px'}}>
                  <li>
                    <a
                      href={Facebook_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="assets/images/facebook-logo.png"
                        alt="Facebook"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      href={Instagram_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="assets/images/instagram-logo.png"
                        alt="Instagram"
                      />{" "}
                    </a>
                  </li>
                  <li>
                    <a
                      href={X_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                    <img src="assets/images/x-logo.png" alt="Telegram" />{" "}
                    </a>
                  </li>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="AF-footer__bottom">
          <div className="AF-container-copy">
            <p className="AF-footer__copyRightContent">
              © {new Date().getFullYear()} MyBetBuilders.com. All rights
              reserved.
            </p>
            <a href={GAMBLEAWARE_URL} target="_blank" rel="noopener noreferrer" ><img style={{height:'15px', marginLeft:'50px'}} src="assets/images/gameleimg.png" alt="gameleimg" /></a>
          </div>
        </div>
      </footer>
      {showPopup && (
        <TermsModal
          showPopup={showPopup}
          handleClose={handleClose}
          activeSection={activeSection}
        />
      )}
    </>
  );
}

export default Footer;
